import { useState, useEffect } from "react";

import CustomButton from "../components/kits/button/CustomButton";

import InventoryContent from "../components/inventory-list-page";
import AddBillModal from "../components/inventory-list-page/AddBillModal";
import FilterBillModal from "../components/inventory-list-page/FilterBillModal";
import { debounce } from "lodash";
import "../components/inventory-list-page/inventory-list-page-style.scss";

import Loader from "../utils/Loader";
import ToastCustomize from "../components/kits/ToastCustomize";

import useAxios from "../services/useAxios.tsx";
import LeavingStoreRoom from "../components/LeavingStoreRoom/Index";
export default function InventoryListPage() {
  const { execute: addRecordApi } = useAxios("record/add_record");
  const { execute: getRecordApi } = useAxios("record/get_records");
  const { execute: exitRecordApi } = useAxios("record/add_exit_record");
  //address api for position react-select
  const { execute: configListApi } = useAxios(
    "http://irancovercrmb.tatdemo.ir/api2/get_configs"
  );
  //address api for product react-select
  const { execute: productListApi } = useAxios(
    "http://irancovercrmb.tatdemo.ir/product/get_products"
  );
  const { execute: userListApi } = useAxios("test/fullusers");
  const { execute: orderListApi } = useAxios("order/get_orders");
  // state for save data in api for position react-select
  const [configItem, setConfigItem] = useState({
    dataPosition: [],
    dataRepository: [],
    dataCheckInType: [],
  });
  // state for save data in api for position react-select
  const [productItem, setProductItem] = useState({
    dataPro: [],
  });
  // state for save data in api for type repository react-select
  const [orders, setOrder] = useState({
    dataOrder: [],
  });
  // state for save data in api for user sender or receiver
  const [userItem, setUserItem] = useState({
    dataUser: [],
  });
  // state for show properties of product when those are selected
  const [showCategory, setShowCategory] = useState({
    data: [],
    dataFilter: [],
  });
  // state for set value on input of react-select postion and product
  const [formValues, setFormValues] = useState({
    position: "",
    product: "",
    productFilter: "",
    userSend: "",
    userReceive: "",
    userSendFilter: "",
    userReceiveFilter: "",
    order: "",
    repository: "",
    repositoryFilter: "",
    desc: "",
    num1: "",
    num2: "",
    checkInType: "",
    loginTime: "",
  });

  // state for validation add bill modal register
  const [showValid, setShowValid] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [pagination, setPagination] = useState(1);

  // function for clear form values
  const clearFormValues = () => {
    setFormValues("");
    // Update show category state
    setShowCategory((prevValues) => ({
      ...prevValues,
      data: [],
    }));
    setShowValid(false);
  };
  // // function for add record api
  const addRecordApiHandler = async () => {
    setShowValid(true);
    if (
      formValues.product &&
      formValues.position &&
      formValues.userSend &&
      formValues.userReceive &&
      formValues.repository &&
      formValues.checkInType &&
      formValues.loginTime
    ) {
      await addRecordApi({
        receipt_type: 1,
        product_id: formValues.product.id,
        count: 1,
        position: formValues.position.value,
        delivery_uid: formValues.userSend.id,
        receiving_uid: formValues.userReceive.id,
        description: formValues.desc ?? "",
        order_id: formValues.order.id ?? "",
        repository_type: formValues.repository.value,
        check_in_out_type: 2,
        check_in_out_place: "",
        check_time: new Date(formValues.loginTime).getTime() / 1000, // convert to timestamp
        parent_id: "",
        properties: "[]",
      }).then((res) => {
        if (res.status === 1) {
          ToastCustomize({
            mainText: res.msg,
            duration: 3000,
            toastType: "success",
            color: "success",
            position: "top-center",
            hasHeader: false,
          });
        } else {
          ToastCustomize({
            mainText: res.msg,
            duration: 3000,
            toastType: "danger",
            color: "danger",
            position: "top-center",
            hasHeader: false,
          });
        }
      });
      // Update data list
      inventoryListFunc();
      // Close add bill modal
      setShowAddBill(false);
      // clear form values
      clearFormValues();
    }
  };

  // function handel change datePicker value
  const handelChangeDate = (e, key) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [key]: e?.toDate?.().toString(),
    }));
  };

  // fuction of product react-select for show properties and set item in input
  const handelChangeSelect = (e, key) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [key]: e,
    }));
  };

  // استیت ذخیره اینپوت های مودال ها   .محمد حسن عباسی ۱۴۰۲/۶/۲
  const handelChangeInput = (e, key) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [key]: e,
    }));
  };
  // function of product value handeler and save property in state
  const productHandeler = (e, propKey, item, changeSelect, key) => {
    let propItem = item.filter((data) => {
      return data.id == e.id;
    });
    setShowCategory((prevState) => ({
      ...prevState,
      [propKey]: propItem[0].properties,
    }));
    changeSelect(e, key);
  };

  // function handel change value property
  const handleChangeProperties = (id, selectedOption, changeProperty) => {
    changeProperty((prevState) => ({
      ...prevState,
      [id]: selectedOption,
    }));
  };
  // استیت ذخیره اینپوت ها برای پراپرتی ها .محمد حسن عباسی ۱۴۰۲/۶/۲
  const handleChangePropertiesّInput = (id, value, changeProperty) => {
    changeProperty((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  // functuion of product api
  const productPostApi = (text) => {
    productListApi({
      page: 1,
      count: 100,
      title: text,
    }).then((data) => {
      const proItem = data.result.map((data) => ({
        value: data.title,
        label: data.title,
        id: data.id,
      }));
      const productProp = data.result.map((data) => ({
        properties: data.properties,
        id: data.id,
      }));
      setProductItem({
        dataPro: { selectItem: proItem, propertiesItem: productProp },
      });
    });
  };
  // function of user sender or receiver api
  const userApi = (text = "", type) => {
    // updated 1402/6/18 by mohammad hasan abbasi
    let postObj = {};
    if (text.trim() === "") {
      postObj = {
        page: 1,
        count: 100,
        // ...(text != "" && { text }),
      };
    } else {
      postObj = {
        page: 1,
        count: 100,
        text: text,
      };
    }
    userListApi(postObj).then((users) => {
      let user = users.data.map((user) => ({
        id: user.id,
        value: user.fname + " " + user.lname + `"(${user.mobile})`,
        label: user.fname + " " + user.lname + `(${user.mobile})`,
      }));
      setUserItem({
        dataUser: [...user],
      });
    });
  };
  // fuction of order request api
  // 1402/6/1 بک اند اصلاح شد و پراپرتی آیدی تغییر دادم.محمد حسن عباسی
  const orderApi = (text) => {
    orderListApi({
      page: 1,
      count: 100,
      type: 1,
      text: text,
    }).then((res) => {
      let optionBox = [];
      res.result.map((response) => {
        let corporate = response.customer[0].corporate;
        let dataName = null;
        if (corporate == "1") {
          dataName = response.customer[0].firstname;
        } else if (corporate == "0") {
          dataName =
            response.customer[0].firstname +
            " " +
            response.customer[0].lastname;
        }

        let options = {
          value:
            response.new_orders__id +
            " " +
            response.customer[0].company_name +
            " " +
            dataName,
          label:
            response.new_orders__id +
            " " +
            response.customer[0].company_name +
            " " +
            dataName,
          id: response.new_orders__id,
        };

        optionBox.push(options);
        setOrder({
          dataOrder: [...optionBox],
        });
      });
    });
  };
  const proDebounce = debounce(productPostApi, 1000);
  const userDebounce = debounce(userApi, 1000);
  const orderDebounce = debounce(orderApi, 1000);
  // call api
  useEffect(() => {
    proDebounce("");
    userDebounce("");
    orderDebounce("");
    configListApi({}).then((data) => {
      setConfigItem({
        dataPosition: [...data.position],
        dataRepository: [...data.repository_type],
        dataCheckInType: [...data.check_in_type],
      });
    });
  }, []);

  const [updater, setUpdater] = useState(false);
  const [inventoryListTotal, setInventoryListTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [inventoryData, setInventoryData] = useState([]);
  const [showAddBill, setShowAddBill] = useState(false);
  const [showFilterBill, setShowFilterBill] = useState(false);

  // function get record api and sender page and count
  const inventoryListFunc = async (page = pagination) => {
    await getRecordApi({ page: page, count: 10 }).then((data) => {
      setInventoryData(data.result);
      setInventoryListTotal(data?.total);
    });
  };

  const [senderUser, setSenderUser] = useState([]);
  const [receiverUser, setReceiverUser] = useState([
    { value: "none", label: "هیچ کدام " },
  ]);

  const [openModal, setOpenModal] = useState(false);

  /**
   *
   * @param {*} check_time
   * @param {*} parent_id
   * @param {*} delivery_uid
   * @param {*} receiving_uid
   */
  const ExitInventory = (
    check_time,
    parent_id,
    delivery_uid,
    receiving_uid
  ) => {
    console.log("d");
    if (
      check_time != "" &&
      parent_id != "" &&
      delivery_uid != "" &&
      receiving_uid != "" &&
      check_time != undefined &&
      parent_id != undefined &&
      delivery_uid != undefined &&
      receiving_uid != undefined
    ) {
      exitRecordApi({
        check_time,
        parent_id,
        delivery_uid,
        receiving_uid,
      }).then((result) => {
        if (result.status === 1) {
          setUpdater((prev) => !prev);
          setOpenModal(false);
          if (result?.msg != "" && result?.msg != undefined)
            ToastCustomize({
              mainText: result.msg,
              duration: 3000,
              toastType: "success",
              color: "success",
              position: "top-center",
              hasHeader: false,
            });
          else
            ToastCustomize({
              mainText: "خروج از انبار با موفقیت انجام شد",
              duration: 3000,
              toastType: "success",
              color: "success",
              position: "top-center",
              hasHeader: false,
            });
        } else {
          if (result?.msg != "" && result?.msg != undefined)
            ToastCustomize({
              mainText: result.msg,
              duration: 3000,
              toastType: "danger",
              color: "danger",
              position: "top-center",
              hasHeader: false,
            });
          else
            ToastCustomize({
              mainText: "متاسفانه مشکلی پیش آمده است.",
              duration: 3000,
              toastType: "danger",
              color: "danger",
              position: "top-center",
              hasHeader: false,
            });
        }
      });
    } else {
      ToastCustomize({
        mainText: "لطفا تمامی مقادیر را پر کنید",
        duration: 5000,
        toastType: "danger",
        color: "danger",
        position: "top-center",
        hasHeader: false,
      });
    }
  };

  // useEffect(() => {
  //   userListApi().then((res) => {
  //     setReceiverUser((prev) => {
  //       return [
  //         ...prev,
  //         ...res.data.map((v) => {
  //           return {
  //             value: v.id,
  //             label: <div>{`${v.fname} ${v.lname} ${v.mobile}`}</div>,
  //           };
  //         }),
  //       ];
  //     });
  //     setSenderUser(res.data);
  //   });
  // }, []);

  useEffect(() => {
    setLoading(true);
    async function LoadPage() {
      await inventoryListFunc();
      setLoading(false);
    }
    LoadPage();
  }, [updater]);
  console.log("setSelectedRecord", selectedRecord);
  return loading ? (
    <Loader />
  ) : (
    <div className="inventory-list-page-style">
      <div className="d-flex align-items-end mb-4">
        <div
          className="mx-1 mb-1 "
          style={{ width: 130, whiteSpace: "nowrap" }}
        >
          <CustomButton
            size="medium "
            className="w-100  justify-content-center "
            onClick={() => {
              setShowAddBill(true);
            }}
            color="primary"
          >
            افزودن قبض ورودی
          </CustomButton>
        </div>
        <div className="mx-1 mb-1" style={{ width: 130 }}>
          <CustomButton
            size="medium "
            className="w-100 justify-content-center"
            onClick={() => {
              setShowFilterBill(true);
            }}
            color="primary"
          >
            فیلتر
          </CustomButton>
        </div>
        {/* <div className="mx-1 mb-1" style={{ width: 110 }}>
          <CustomButton
            size="medium "
            className="w-100 justify-content-center"
            onClick={() => {
              setOpenModal(true);
            }}
            color="primary"
          >
            خروج از انبار
          </CustomButton>
        </div> */}
      </div>
      <InventoryContent
        inventoryData={inventoryData}
        setUpdater={setUpdater}
        inventoryListTotal={inventoryListTotal}
        inventoryListFunc={inventoryListFunc}
        setOpenModal={setOpenModal}
        setSelectedRecord={setSelectedRecord}
        pagination={pagination}
        setPagination={setPagination}
      />

      <LeavingStoreRoom
        openModal={openModal}
        setOpenModal={setOpenModal}
        receiverUser={receiverUser}
        setReceiverUser={setReceiverUser}
        senderUser={senderUser}
        setSenderUser={setSenderUser}
        userApi={userApi}
        userListApi={userListApi}
        userDebounce={userDebounce}
        userItem={userItem}
        ExitInventory={ExitInventory}
        selectedRecord={selectedRecord}
      ></LeavingStoreRoom>

      <AddBillModal
        orders={orders}
        showCategory={showCategory}
        formValues={formValues}
        handleChangeProperties={handleChangeProperties}
        handleChangePropertiesّInput={handleChangePropertiesّInput}
        handelChangeSelect={handelChangeSelect}
        handelChangeInput={handelChangeInput}
        productHandeler={productHandeler}
        configItem={configItem}
        productItem={productItem}
        proDebounce={proDebounce}
        orderDebounce={orderDebounce}
        userDebounce={userDebounce}
        userItem={userItem}
        show={showAddBill}
        setShow={setShowAddBill}
        handelChangeDate={handelChangeDate}
        addRecordApiHandler={addRecordApiHandler}
        clearFormValues={clearFormValues}
        showValid={showValid}
      />
      <FilterBillModal
        showCategory={showCategory}
        formValues={formValues}
        handleChangeProperties={handleChangeProperties}
        handleChangePropertiesّInput={handleChangePropertiesّInput}
        handelChangeSelect={handelChangeSelect}
        handelChangeInput={handelChangeInput}
        productHandeler={productHandeler}
        productItem={productItem}
        configItem={configItem}
        proDebounce={proDebounce}
        userDebounce={userDebounce}
        userItem={userItem}
        show={showFilterBill}
        setShow={setShowFilterBill}
      />
    </div>
  );
}
